export const createleaveclarification=`mutation CreateLeaveClarification( 

  $userId: Int! 

  $leaveTypeId: Int! 

  $departmentId: Int! 

  $fromDate: Date! 

  $toDate: Date! 

  $leaveBalanceInquiry: Boolean! 

) { 

  createLeaveClarification( 

    userId: $userId 

    leaveTypeId: $leaveTypeId 

    departmentId: $departmentId 

    fromDate: $fromDate 

    toDate: $toDate 

    leaveBalanceInquiry: $leaveBalanceInquiry 

  ) { 

    leaveClarification{ 

      id 

      user{ 

        id 

        empid 

        department 

        designation 

        firstName 

        lastName         

      } 

      leaveType{ 

        id 

        name         

      } 

      department{ 

        id 

        departmentName 

      } 

      fromDate 

      toDate 

      leaveBalanceInquiry 

      createdAt 

      lastUpdated 

    } 

    success 

    message 

    error 

  } 

} `


export const updateLeaveclarification=`mutation UpdateLeaveClarification( 
   $id: Int!, 

  $fromDate: Date, 

  $toDate: Date, 

  $leaveBalanceInquiry: Boolean, 

  $leaveTypeId: Int, 

  $departmentId: Int 

) { 

  updateLeaveClarification( 

    id: $id, 

    fromDate: $fromDate, 

    toDate: $toDate, 

    leaveBalanceInquiry: $leaveBalanceInquiry, 

    leaveTypeId: $leaveTypeId, 

    departmentId: $departmentId 

  ) { 

    leaveClarification{ 

      id 

      user{ 

        id 

        empid 

        department 

        designation 

        firstName 

        lastName         

      } 

      leaveType{ 

        id 

        name         

      } 

      department{ 

        id 

        departmentName 

      } 

      fromDate 

      toDate 

      leaveBalanceInquiry 

      createdAt 

      lastUpdated 

    } 

    success 

    message 

    error 

  } 

} `


export const getallleaveclarification=`query { 

  allLeaveClarifications { 

    leaveClarifications { 

      id 

      user{ 

        id 

        empid 

        department 

        designation 

        firstName 

        lastName         

      } 

      leaveType{ 

        id 

        name         

      } 

      department{ 

        id 

        departmentName 

      } 

      fromDate 

      toDate 

      leaveBalanceInquiry 

      createdAt 

      lastUpdated 

    } 

    success 

    message 

    error 

  } 

} `


export const deleteleaveclarification=`mutation DeleteLeaveClarification($id: Int!) { 

  deleteLeaveClarification(id: $id) { 

    success 

    message 

    error 

  } 

} 
 `

 export const  getbyid=`query GetLeaveClarificationById($id: ID!) { 

  leaveClarificationById(id: $id) { 

    leaveClarification { 

     id 

      user{ 

        id 

        empid 

        department 

        designation 

        firstName 

        lastName         

      } 

      leaveType{ 

        id 

        name         

      } 

      department{ 

        id 

        departmentName 

      } 

      fromDate 

      toDate 

      leaveBalanceInquiry 

      createdAt 

      lastUpdated 

    } 

    success 

    message 

    error 

  } 

} `